import src from "IMAGE";
export default { src, width: 464, height: 128, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANElEQVR42l3KsQ0AIAhEUaYwsQDj3ng3D4nuJIU2vPLnizwtkQwsHDObUqnqcPcAsPPtv1+SPQw0YfIuPgAAAABJRU5ErkJggg=="};
